// import React from "react";
// import { Box, Stack, Typography } from "@mui/material";

// const ResourcePricingCard = ({ price, organizationName, showUnit = false, showHourly = true }) => {
//   const formatPrice = (value, decimals) =>
//     showUnit
//       ? new Intl.NumberFormat("en-US", {
//           style: "currency",
//           currency: price.currency,
//           minimumFractionDigits: decimals,
//           maximumFractionDigits: decimals,
//         }).format(value)
//       : `$${Number(value).toFixed(decimals)}`;

//   return (
//     <Stack spacing={2.5}>
//       <Box
//         sx={{
//           border: 1,
//           borderColor: (t) => t.palette.mode === "dark" ? "divider" : "#d9e8f6",
//           borderRadius: 2,
//           bgcolor: (t) => t.palette.mode === "dark" ? "background.default" : "#ffffffb4",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             px: 1.5,
//             py: 1,
//             bgcolor: (t) => t.palette.mode === "dark" ? "var(--app-bg-soft)" : "#d9e8f6",
//             borderRadius: "8px 8px 2px 2px",
//           }}
//         >
//           <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
//             <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "text.primary" }}>
//               Forecasted Cost
//             </Typography>
//             <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
//               ({organizationName || "Gainwell Technologies"})
//             </Typography>
//           </Box>
//         </Box>
//         <Box sx={{ px: 1.5, py: 1.5 }}>
//           {[
//             ["month", price.pricePerMonth, 2],
//             ["hour", price.pricePerHr, 3],
//           ].filter(([period]) => showHourly || period !== "hour").map(([period, value, decimals]) => (
//             <Box key={period} sx={{ mb: period === "month" ? 1 : 0 }}>
//               <Typography sx={{ mb: 0.5, fontWeight: 600, color: "text.primary" }}>
//                 Price per {period}
//               </Typography>
//               <Typography
//                 component="span"
//                 variant="h5"
//                 sx={{
//                   fontWeight: 700,
//                   color: (t) => t.palette.mode === "dark" ? "#81c784" : "#0d7a46",
//                   fontSize: "1.5rem",
//                 }}
//               >
//                 {formatPrice(value, decimals)}
//               </Typography>
//               <Typography component="span" variant="body1" sx={{ color: "text.secondary", ml: 0.5 }}>
//                 / {period}
//               </Typography>
//             </Box>
//           ))}
//           {showUnit && (
//             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//               Rate unit: {price.unitOfMeasure}
//             </Typography>
//           )}
//         </Box>
//       </Box>
//     </Stack>
//   );
// };

// export default ResourcePricingCard;



import React from "react";
import { Box, Stack, Typography } from "@mui/material";

const ResourcePricingCard = ({
  price,
  organizationName,
  showUnit = false,
  showHourly = true,
}) => {
  const formatPrice = (value, decimals) => {
    const amount = Number(value);

    if (!Number.isFinite(amount)) return "—";

    if (showUnit) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: price?.currency || "USD",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }).format(amount);
    }

    return `$${amount.toFixed(decimals)}`;
  };

  const storageRows = [
    ["Product", price?.productName],
    ["SKU", price?.skuName],
    ["Meter", price?.meterName],
  ];

  return (
    <Stack spacing={2.5}>
      <Box
        sx={{
          border: 1,
          borderColor: (theme) =>
            theme.palette.mode === "dark" ? "divider" : "#d9e8f6",
          borderRadius: 2,
          bgcolor: (theme) =>
            theme.palette.mode === "dark"
              ? "background.default"
              : "#ffffffb4",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 1.5,
            py: 1,
            bgcolor: (theme) =>
              theme.palette.mode === "dark"
                ? "var(--app-bg-soft)"
                : "#d9e8f6",
            borderRadius: "8px 8px 2px 2px",
          }}
        >
          <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Forecasted Cost
            </Typography>
            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
              ({organizationName || "Gainwell Technologies"})
            </Typography>
          </Box>
        </Box>

        <Box sx={{ px: 1.5, py: 1.5 }}>
          {showUnit &&
            storageRows.map(([label, value]) => (
              <Box
                key={label}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                  py: 0.75,
                  borderBottom: 1,
                  borderColor: "divider",
                }}
              >
                <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
                <Typography color="text.secondary">{value || "—"}</Typography>
              </Box>
            ))}

          {[
            ["month", price?.pricePerMonth, showUnit ? 4 : 2],
            ["hour", price?.pricePerHr, 3],
          ]
            .filter(([period]) => showHourly || period !== "hour")
            .map(([period, value, decimals]) => (
              <Box key={period} sx={{ mt: 1, mb: period === "month" ? 1 : 0 }}>
                <Typography sx={{ mb: 0.5, fontWeight: 600 }}>
                  {showUnit ? "Price per GB/month" : `Price per ${period}`}
                </Typography>

                <Typography
                  component="span"
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#81c784" : "#0d7a46",
                    fontSize: "1.5rem",
                  }}
                >
                  {formatPrice(value, decimals)}
                </Typography>

                <Typography
                  component="span"
                  variant="body1"
                  sx={{ color: "text.secondary", ml: 0.5 }}
                >
                  / {showUnit ? "GB/month" : period}
                </Typography>
              </Box>
            ))}

          {showUnit && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
                pt: 1,
                borderTop: 1,
                borderColor: "divider",
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>Billing unit</Typography>
              <Typography color="text.secondary">
                {price?.unitOfMeasure || "—"}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Stack>
  );
};

export default ResourcePricingCard;
